// extracted by mini-css-extract-plugin
export default {"content":"upc-faqs_content__3jn6D","noteText":"upc-faqs_noteText__BWczQ","infoIcon":"upc-faqs_infoIcon__EvW5P","infoText":"upc-faqs_infoText__wTpVK"};